// 结构
export class BaseStructure {
  constructor(props) {
    this.props = props
  }

  // 预设列表, 留给子类实现
  presets() {
    if (process.env.NODE_ENV === 'development') {
      console.log(this.constructor.name + 'must implement presets() function')
    }
  }
  
  /*
  * 当前的结构（props 中指定了 preset）
  * return
  *   props 中指定了 preset -
  *     找到了返回结构 html
  *     未找到返回 `未定义`
  *   props 未指定 preset: 直接返回未指定预设错误信息
  * */
  current() {
    if (!this.props.preset) {
      return `ERROR (${this.constructor.name}): 未指定预设`
    }
    
    const preset = this.find_preset_by_uid(this.props.preset)
    return preset ? preset.html : `ERROR: 预设【preset uid: ${ this.props.preset }】未定义`
  }

  // 通过预设的 uid 查找预设的结构
  find_preset_by_uid(uid) {
    return this.presets().find(preset => preset.uid === uid.toString())
  }

  //
  customizeWidthClass() {
    if (!this.customize) return ''
    switch (this.customize.width) {
      case 'arrow-x': return 'max-width-600'; break;
      case 'arrow': return 'max-width-800'; break;
      case 'fullscreen': return 'fullscreen-width'; break;
    }
  }

  customizeHeightClass() {
    if (!this.customize) return ''
    switch (this.customize.height) {
      case 'none': return 'section-padding-0'; break;
      case 'default': return 'section-padding-50'; break;
      case 'loose': return 'section-padding-100'; break;
      case 'fullscreen': return 'height-fullscreen'; break;
    }
  }

  customizeAlignClass() {
    if (!this.customize) return ''
    switch (this.customize.align) {
      case 'left': return 'text-left'; break;
      case 'center': return 'text-center'; break;
      case 'right': return 'text-right'; break;
    }
  }

  //
  customizeDeviceClass() {
    if (!this.customize || !this.customize.displayToDevices) return ''
    //
    const allDevices = "desktop,laptop,pad,mobile".split(',')
    const devices = (this.customize.displayToDevices || "").split(",")
    let classes = []
    for (let device of allDevices) {
      if (!devices.includes(device)) {
        classes.push('hide-at-device-'+device)
      }
    }
    return classes.join(" ")
  }

  // 自定义设计的样式
  customizeDesignStyles() {
    if (!this.customize) return {}
    let styles = {}
    if (this.customize.backgroundColor) styles.backgroundColor = this.customize.backgroundColor
    if (this.customize.fontColor) styles.color = this.customize.fontColor
    return styles
  }

  customizeClassName() {
    return " " + [
      this.customizeWidthClass(),
      this.customizeHeightClass(),
      this.customizeAlignClass(),
      this.customizeDeviceClass()
    ].join(" ")
  }

  // 格式化链接地址
  static formatSiteNavLinks = (nav, host) => {
    let links = []
    nav.map(link => {
      if (link.url === '/' || link.type === 'theme/homepage') { // 重新设置首页链接地址
        links.push(Object.assign({}, link, {url: (host || '') + link.url}))
      } else {
        links.push(link)
      }
    })
    return links
  }
}

export default BaseStructure


// WEBPACK FOOTER //
// ./app/javascript/app/site/structures/base.js